// extracted by mini-css-extract-plugin
module.exports = {"cell":"SearchTableHeadCell_cell__3DyL4","field":"SearchTableHeadCell_field__2DY7_","icon":"SearchTableHeadCell_icon__3XWR6"};